import { useSessionStore } from '@/stores/useSessionStore';
import { authClientApi, logoutUser, renewLogin, type UserCredentials } from '@/api/authClientApi';
import type { SessionLength } from '@/constants/browserStorage';
import { useUserStore } from '@/stores/useUserStore';
import { logoutAgent } from '@/api/useAgents';

export const useAuthService = () => {
  const $sessionStore = useSessionStore();

  const login = async (userCredentials: UserCredentials, sessionLength: SessionLength) => {
    const session = await authClientApi(userCredentials, sessionLength);
    $sessionStore.createSession({ ...session, sessionLength: sessionLength });
  };

  const logout = async () => {
    const $userStore = useUserStore();
    if ($userStore._loggedInUser.agentUuid) logoutAgent($userStore._loggedInUser.agentUuid);
    await logoutUser();
    await $sessionStore.logoutSession();
  };

  const refreshToken = async () => {
    if ($sessionStore._session.isAuthenticated === false) return Promise.reject('Not authenticated');
    const { domain, sessionLength } = $sessionStore._session;
    try {
      const newSessionData = await renewLogin(domain, sessionLength);
      $sessionStore.createSession(newSessionData);
    } catch (error) {
      console.error('Error refreshing token:', error);
      throw error;
    }
  };

  return {
    login,
    logout,
    refreshToken,
  };
};
